import { render, staticRenderFns } from "./WallkitPlanCard.vue?vue&type=template&id=056aebbb"
import script from "./WallkitPlanCard.vue?vue&type=script&lang=js"
export * from "./WallkitPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports